/**
 * @author Ivan Toth.
 */
var DetailTableComplClInvestmentReviewController = (function () {
    function DetailTableComplClInvestmentReviewController(topic, $scope, settings) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.settings = settings;
        this.tableName = 'Investment Review Checklist';
        this.displayRadioButton = true;
        this.lock = true;
        this.enableSection = true;
        this.comp = 'complcl_investment_review';
        this.updateArray = ['complcl_investment_review'];
        this.visible = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    ;
    DetailTableComplClInvestmentReviewController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableComplClInvestmentReviewController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailTableComplClInvestmentReviewController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateGeneral(this.updateArray, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableComplClInvestmentReviewController.prototype.itemChanged = function (line) { };
    DetailTableComplClInvestmentReviewController.$inject = ['topic', '$scope', 'settings'];
    return DetailTableComplClInvestmentReviewController;
}());
var DetailTableComplClInvestmentReviewComponent = (function () {
    function DetailTableComplClInvestmentReviewComponent() {
        this.templateUrl = 'detail-table-complcl.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableComplClInvestmentReviewController;
    }
    return DetailTableComplClInvestmentReviewComponent;
}());
angular
    .module('application')
    .component('detailTableComplClInvestmentReview', new DetailTableComplClInvestmentReviewComponent());

//# sourceMappingURL=detail.table.compl.cl.investment.review.component.js.map
